export const routesApp = {
  sendEmail: '/',
  sendCode: '/auth/send-code',
  peoples: '/peoples',
  peoplesVaccines: '/peoples/vaccines',
  peoplesDiseases: '/peoples/diseases',
  peoplesCountries: '/peoples/countries',
  peoplesReactions: '/peoples/reactions',
  pets: '/pets',
  petsVaccines: '/pets/vaccines',
  petsDiseases: '/pets/diseases',
  petsCountries: '/pets/countries',
  petsBreeds: '/pets/breeds',
  petsReactions: '/pets/reactions',
  users: '/users',
  breeds: '/breeds',
  voices: '/voices',
  pharmaCompanies: '/pharmaCompanies',
  analytics: '/analytics',
  supportMessages: '/support-messages',
  translations: '/translations',
}
